export const Messages = {
  FileManager: {
    invalidFileSizeMessageSummary: 'File troppo grande. ',
    invalidFileSizeMessageDetail: 'Il File supera le dimensioni massime consentite.'
  },
  FormYearInputText: {
    invalidInputData: 'Anno non valido, deve essere nella forma YYYY.',
    invalidMaxLenghtData: 'Anno non valido, deve essere nella forma YYYY.'
  },
  FormSelectDevice: {
    emptyMessage: 'Nessun dispositivo disponibile',
    tooltip: 'Verranno elencati solo i dispositivi non ancora associati ad un veicolo'
  },
  FormSelectModel: {
    emptyMessage: '* Modello obbligatorio.'
  },
  FormPlateInputText: {
    emptyMessage: '* Targa veicolo obbligatoria.'
  },
  DataTableVehicleList: {
    emptyMessage: 'Nessun veicolo trovato.'
  },
  DataTableEventList: {
    emptyMessage: 'Nessun evento trovato.'
  },
  DataTableTripList: {
    emptyMessage: 'Nessun viaggio trovato.'
  },
  DataTableDeviceList: {
    emptyMessage: 'Nessun dispositivo trovato.'
  },
  DataTableLastTrips: {
    emptyMessage: 'Non ci sono viaggi in corso.'
  },
  DataTableVehicleTrips: {
    emptyMessage: 'Nessun viaggio trovato.'
  },
  FormPukInputText: {
    emptyMessage: '* Campo PUK obbligatorio.'
  },
  FormPinInputText: {
    emptyMessage: '* Campo PIN obbligatorio.'
  },
  FormNumeroInputText: {
    emptyMessage: '* Campo NUMERO obbligatorio.'
  },
  FormImeiInputText: {
    emptyMessage: '* Campo IMEI obbligatorio.'
  },
  GetAddress: {
    streetNotFound: 'Strada non disponibile'
  },
  ToastSuccess: {
    summary: 'Operazione eseguita',
    detail: 'Operazione eseguita con successo!'
  },
  ToastError: {
    summary: 'Si è verificato un errore',
    detail: 'Si è verificato un errore imprevisto!'
  },
  HttpErrorDecode: {
    notFound: 'risorsa non esistente o eliminata!',
    conflict: 'I seguenti campi sono già esistenti: ',
    conflictData: 'si è verificato un conflitto con i dati sul server',
    manyRequest: 'troppe richieste! Attendi qualche secondo e ripetila',
    badGateway: 'Server temporaneamente non disponibile. Riprova tra qualche minuto. Se persiste contattare il supporto',
    unexpectedError: 'Errore tecnico imprevisto. Riprova più tardi. Se persiste contattare il supporto'
  },
  WsInProgress: {
    onMessageFinish: 'Trip Terminato!'
  },
  GoogleMap: {
    loadingData: 'Cercando la posizione...'
  },
  DataPicker: {
    noDataTimeMessage: 'Nessun risultato per questo orario. Prova cambiando orario!',
    infoSearchPosPrecision: "Nel caso non venga trovata una posizione nell'orario specificato, " +
    "viene restituita la posizione nell'orario più vicino per un massimo di un'ora di differenza, " +
    'altrimenti provare a cambiare orario.'
  },
  Tooltip: {
    ButtonOpenCloseMenu: 'apri/chiudi menu',
    ButtonRefreshPosition: 'Aggiorna posizioni',
    ButtonDeletImage: 'Elimina immagine',
    ButtonGoToTripsInProgress: 'Visualizza viaggi in corso',
    ButtonGoToTrips: 'Vai ai viaggi del veicolo',
    ButtonEditVehicle: 'Vedi dettaglio veicolo',
    ButtonDeletVehicle: 'Elimina veicolo',
    ButtonSearchVehicles: 'Cerca veicoli',
    ButtonCreateVehicle: 'crea un nuovo veicolo',
    ButtonSearchPositionVehicle: 'Trova posizione veicolo tramite data e ora.',
    ButtonEditDevice: 'Modifica dispositivo',
    ButtonDeletDevice: 'Elimina dispositivo',
    ButtonSearchDevice: 'cerca dispositivi',
    ButtonCreateDevice: 'crea un nuovo dispositivo'
  },
  TripSummary: {
    renderMaxSpeed: 'Velocità massima',
    renderAVGSpeeg: 'Velocità media',
    renderIdleTime: 'Tempo inattività',
    renderDuration: 'Durata viaggio',
    renderDurationMulti: 'Durata viaggi',
    renderNumEvents: 'Eventi ricevuti',
    renderKM: 'Km percorsi',
    renderEcoScore: 'Eco Score',
    renderFuelUsed: 'Carburante usato',
    defaultMessRenderEndDate: 'Viaggio in corso...'
  }
}
